// extracted by mini-css-extract-plugin
export default {"MMAIwrapper":"Input_MMAIwrapper__fm7ri","MMAItext":"Input_MMAItext__dcj01","MMAIbtn":"Input_MMAIbtn__8Kpas"};